// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FadeController from "./fade_controller"
application.register("fade", FadeController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)
